<h1>Accounts Remarks <button type="button" (click)="CloseModal()" class="btn btn-default float-right">Close</button></h1>
<div class="border-with-marg"></div>
<div class="row">
    <div class="col-sm-12">
        <form [formGroup]="accountsForm" (submit)="save_payment_remarks()">
            <div *ngIf="data_loading" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></div>
            <div *ngIf="err_msg" class="text-center red bold">{{err_msg}}</div>
            <div formArrayName="receivedAmtResources" style="display: contents;">
                <div class="row mt-3 bottom-arrow"  *ngFor="let quantity of receivedAmtResources().controls; let i=index" [formGroupName]="i">
                    
                    <div class="col-md-4">
                        <label class="form-label">Received Amount</label>
                        <input type="number" formControlName="received_amt" class="form-control text-left receive_amount" [readonly]="true"/>
                    </div>
                    <div class="col-sm-3">
                        <label class="form-label">Payment Mode</label>
                        <mat-select placeholder="Select Payment" formControlName="payment_mode" [disabled]="true">
                            <mat-option [value]="1">Cash</mat-option>
                            <mat-option [value]="2">Cheque</mat-option>
                            <mat-option [value]="3">Razor Pay</mat-option>
                            <mat-option [value]="4">EMI</mat-option>
                            <mat-option [value]="5">Net Banking</mat-option>
                            <mat-option [value]="6">Insurance</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">Payment Screenshot Link</label>
                        <input type="text" formControlName="payment_screenshot_link" class="form-control text-left" [readonly]="true"/>
                    </div>
                    <div class="col-md-1" *ngIf="accountsForm.value.receivedAmtResources[i].payment_screenshot_link">
                        <label class="form-label">&nbsp;</label>
                        <a target="_blank" href="{{accountsForm.value.receivedAmtResources[i].payment_screenshot_link}}">View</a>
                    </div>
                    <input type="hidden" formControlName="scanPaymentId" >

                    <div class="col-sm-2 mt-6">
                        <label class="form-label">Verified by Accounts</label>
                        <mat-select placeholder="Select Payment" formControlName="verified_by_accounts" [disabled]="other_role_field_disabled">
                            <mat-option value="Yes">Yes</mat-option>
                            <mat-option value="No">No</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-md-3 mt-6">
                        <label class="form-label">Received Amount</label>
                        <input type="text" formControlName="rec_amount_by_account" class="form-control text-left" [readonly]="other_role_field_disabled"/>
                    </div>
                    <div class="col-sm-3 mt-6">
                    <label class="form-label">Payment Received Date</label>
                    <mat-form-field appearance="fill">
                        <mat-label>Choose a date</mat-label>
                        <input  matInput readonly formControlName="payment_rec_date_by_acc" [matDatepicker]="picker" [disabled]="other_role_field_disabled">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                    </div>
                    <div class="col-sm-4 mt-6">
                        <label class="form-label">Accounts Remarks</label>
                        <textarea rows="3" placeholder="Accounts Remarks" formControlName="accounts_remarks" class="form-control" [readonly]="other_role_field_disabled"></textarea>
                    </div>
                </div>
            </div>

            <div class="card-footer mt-5" *ngIf="myrole == '1' || myrole == '9'">
                <button type="submit" [disabled]="loading || data_loading || err_msg" class="btn btn-primary"><i *ngIf="loading"
                    class="fa fa-spin fa-spinner"></i> Submit</button>
            </div>
        </form>
    </div>

</div>